import { c as _c } from "react/compiler-runtime";
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next/pages';
import { ReactElement } from 'react';
import { FooterLink } from './FooterLink';
export function Footer() {
  const $ = _c(118);
  const {
    t
  } = useTranslation("apps-resources");
  const gitSha = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ?? process.env.VERCEL_GIT_COMMIT_SHA ?? "";
  const shortSha = gitSha ? gitSha.substring(0, 7).toLowerCase() : "dev";
  const projectInfo = `Resources (${shortSha})`;
  let t0;
  if ($[0] !== t) {
    t0 = t("Share", {
      lng: "en"
    });
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      name: t0,
      href: "/partners/share/"
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("Watch", {
      lng: "en"
    });
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      name: t2,
      href: "/watch/"
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("Giving", {
      lng: "en"
    });
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = {
      name: t4,
      href: "/give/"
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("About", {
      lng: "en"
    });
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = {
      name: t6,
      href: "/about/"
    };
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("Products", {
      lng: "en"
    });
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = {
      name: t8,
      href: "/products/"
    };
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("Resources", {
      lng: "en"
    });
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = {
      name: t10,
      href: "/partners/resources/"
    };
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("Partners", {
      lng: "en"
    });
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12) {
    t13 = {
      name: t12,
      href: "/partners/"
    };
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t) {
    t14 = t("Contact", {
      lng: "en"
    });
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14) {
    t15 = {
      name: t14,
      href: "/contact/"
    };
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t1 || $[33] !== t11 || $[34] !== t13 || $[35] !== t15 || $[36] !== t3 || $[37] !== t5 || $[38] !== t7 || $[39] !== t9) {
    t16 = [t1, t3, t5, t7, t9, t11, t13, t15];
    $[32] = t1;
    $[33] = t11;
    $[34] = t13;
    $[35] = t15;
    $[36] = t3;
    $[37] = t5;
    $[38] = t7;
    $[39] = t9;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  const navigationLinks = t16;
  let t17;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = [{
      name: "X (Twitter)",
      href: "https://twitter.com/jesusfilm",
      icon: "/journeys/assets/footer/x-twitter.svg"
    }, {
      name: "Facebook",
      href: "https://www.facebook.com/jesusfilm",
      icon: "/journeys/assets/footer/facebook.svg"
    }, {
      name: "Instagram",
      href: "https://www.instagram.com/jesusfilm",
      icon: "/journeys/assets/footer/instagram.svg"
    }, {
      name: "YouTube",
      href: "https://www.youtube.com/user/jesusfilm",
      icon: "/journeys/assets/footer/youtube.svg"
    }];
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  const socialLinks = t17;
  let t18;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      backgroundColor: "background.default",
      pt: 10,
      pb: 10
    };
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      alignItems: "center",
      justifyContent: "space-between",
      gap: 5,
      flexWrap: "wrap",
      rowGap: {
        xs: 8,
        sm: 5
      },
      "& > *:nth-child(1)": {
        order: 1
      },
      "& > *:nth-child(2)": {
        order: 2
      },
      "& > *:nth-child(3)": {
        order: 3
      },
      "& > *:nth-child(4)": {
        order: {
          xs: 0,
          sm: 4
        }
      }
    };
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <FooterLink url="/" label="Jesus Film logo" src="/journeys/assets/footer/jesus-film-logo.png" width={60} height={60} sx={{
      lineHeight: 0
    }} />;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Stack direction="row" sx={{
      gap: {
        xs: 10,
        sm: 5
      },
      ml: {
        sm: "auto"
      },
      mr: {
        sm: 5
      },
      flexGrow: {
        xs: 1,
        sm: 0
      },
      justifyContent: {
        xs: "center",
        sm: "flex-start"
      },
      flexBasis: {
        xs: "100%",
        sm: "auto"
      }
    }}>{socialLinks.map(_temp2)}</Stack>;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      flexWrap: "wrap",
      justifyContent: "center",
      columnGap: {
        xs: 10,
        sm: 5
      },
      rowGap: 5
    };
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== navigationLinks) {
    t23 = <Stack direction="row" sx={t22}>{navigationLinks.map(_temp3)}</Stack>;
    $[47] = navigationLinks;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      p: "8px 13px 7px",
      borderRadius: 20,
      lineHeight: "1.1334",
      height: "34px"
    };
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t) {
    t25 = t("Give Now", {
      lng: "en"
    });
    $[50] = t;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== t25) {
    t26 = <Button component="a" href="/how-to-help/ways-to-donate/give-now/?amount=&frequency=single&campaign-code=NXWJPO&designation-number=2592320&thankYouRedirect=/dev/special/thank-you-refer/social-share/" variant="contained" color="primary" size="small" sx={t24}>{t25}</Button>;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t23 || $[55] !== t26) {
    t27 = <Stack direction="row" sx={t19}>{t20}{t21}{t23}{t26}</Stack>;
    $[54] = t23;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 5,
      rowGap: 8
    };
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  let t30;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Divider orientation="vertical" flexItem={true} />;
    t30 = {
      justifyContent: {
        xs: "center",
        sm: "flex-start"
      },
      flexGrow: 1,
      alignItems: "center",
      gap: 5
    };
    $[58] = t29;
    $[59] = t30;
  } else {
    t29 = $[58];
    t30 = $[59];
  }
  let t31;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = {
      fontSize: 12,
      lineHeight: 1.2
    };
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== t) {
    t32 = t("100 Lake Hart Drive", {
      lng: "en"
    });
    $[61] = t;
    $[62] = t32;
  } else {
    t32 = $[62];
  }
  let t33;
  if ($[63] !== t32) {
    t33 = <Typography variant="h6" sx={t31}>{t32}</Typography>;
    $[63] = t32;
    $[64] = t33;
  } else {
    t33 = $[64];
  }
  let t34;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = {
      fontSize: 12,
      lineHeight: 1.2
    };
    $[65] = t34;
  } else {
    t34 = $[65];
  }
  let t35;
  if ($[66] !== t) {
    t35 = t("Orlando, FL, 32832", {
      lng: "en"
    });
    $[66] = t;
    $[67] = t35;
  } else {
    t35 = $[67];
  }
  let t36;
  if ($[68] !== t35) {
    t36 = <Typography variant="h6" sx={t34}>{t35}</Typography>;
    $[68] = t35;
    $[69] = t36;
  } else {
    t36 = $[69];
  }
  let t37;
  if ($[70] !== t33 || $[71] !== t36) {
    t37 = <Stack>{t33}{t36}</Stack>;
    $[70] = t33;
    $[71] = t36;
    $[72] = t37;
  } else {
    t37 = $[72];
  }
  let t38;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = {
      fontSize: 12,
      lineHeight: 1.2
    };
    $[73] = t38;
  } else {
    t38 = $[73];
  }
  let t39;
  if ($[74] !== t) {
    t39 = t("Office: (407) 826-2300", {
      lng: "en"
    });
    $[74] = t;
    $[75] = t39;
  } else {
    t39 = $[75];
  }
  let t40;
  if ($[76] !== t39) {
    t40 = <Typography variant="h6" sx={t38}>{t39}</Typography>;
    $[76] = t39;
    $[77] = t40;
  } else {
    t40 = $[77];
  }
  let t41;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = {
      fontSize: 12,
      lineHeight: 1.2
    };
    $[78] = t41;
  } else {
    t41 = $[78];
  }
  let t42;
  if ($[79] !== t) {
    t42 = t("Fax: (407) 826-2375", {
      lng: "en"
    });
    $[79] = t;
    $[80] = t42;
  } else {
    t42 = $[80];
  }
  let t43;
  if ($[81] !== t42) {
    t43 = <Typography variant="h6" sx={t41}>{t42}</Typography>;
    $[81] = t42;
    $[82] = t43;
  } else {
    t43 = $[82];
  }
  let t44;
  if ($[83] !== t40 || $[84] !== t43) {
    t44 = <Stack>{t40}{t43}</Stack>;
    $[83] = t40;
    $[84] = t43;
    $[85] = t44;
  } else {
    t44 = $[85];
  }
  let t45;
  if ($[86] !== t) {
    t45 = t("Privacy Policy", {
      lng: "en"
    });
    $[86] = t;
    $[87] = t45;
  } else {
    t45 = $[87];
  }
  let t46;
  if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = {
      fontSize: 12,
      lineHeight: 1.2
    };
    $[88] = t46;
  } else {
    t46 = $[88];
  }
  let t47;
  if ($[89] !== t45) {
    t47 = <FooterLink url="/privacy/" label={t45} sx={t46} />;
    $[89] = t45;
    $[90] = t47;
  } else {
    t47 = $[90];
  }
  let t48;
  if ($[91] !== t) {
    t48 = t("Legal Statement", {
      lng: "en"
    });
    $[91] = t;
    $[92] = t48;
  } else {
    t48 = $[92];
  }
  let t49;
  if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = {
      fontSize: 12,
      lineHeight: 1.2
    };
    $[93] = t49;
  } else {
    t49 = $[93];
  }
  let t50;
  if ($[94] !== t48) {
    t50 = <FooterLink url="/legal/" label={t48} sx={t49} />;
    $[94] = t48;
    $[95] = t50;
  } else {
    t50 = $[95];
  }
  let t51;
  if ($[96] !== t47 || $[97] !== t50) {
    t51 = <Stack>{t47}{t50}</Stack>;
    $[96] = t47;
    $[97] = t50;
    $[98] = t51;
  } else {
    t51 = $[98];
  }
  let t52;
  if ($[99] !== t37 || $[100] !== t44 || $[101] !== t51) {
    t52 = <Stack direction="row" divider={t29} sx={t30}>{t37}{t44}{t51}</Stack>;
    $[99] = t37;
    $[100] = t44;
    $[101] = t51;
    $[102] = t52;
  } else {
    t52 = $[102];
  }
  let t53;
  if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <Typography variant="h6" color="textSecondary" sx={{
      fontSize: 12,
      lineHeight: 1.2,
      opacity: 0.6
    }}>{projectInfo}</Typography>;
    $[103] = t53;
  } else {
    t53 = $[103];
  }
  let t54;
  if ($[104] !== t52) {
    t54 = <Stack direction="column">{t52}{t53}</Stack>;
    $[104] = t52;
    $[105] = t54;
  } else {
    t54 = $[105];
  }
  let t55;
  if ($[106] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = {
      flexGrow: 1,
      alignItems: {
        xs: "center",
        sm: "flex-end"
      }
    };
    $[106] = t55;
  } else {
    t55 = $[106];
  }
  let t56;
  if ($[107] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = {
      backgroundColor: "#333",
      color: "white",
      p: "8px 13px 7px",
      borderRadius: 20,
      lineHeight: "1.1334",
      height: "34px"
    };
    $[107] = t56;
  } else {
    t56 = $[107];
  }
  let t57;
  if ($[108] !== t) {
    t57 = t("Sign Up For Our Newsletter", {
      lng: "en"
    });
    $[108] = t;
    $[109] = t57;
  } else {
    t57 = $[109];
  }
  let t58;
  if ($[110] !== t57) {
    t58 = <Stack sx={t55}><Button component="a" href="/email/" variant="contained" size="small" sx={t56}>{t57}</Button></Stack>;
    $[110] = t57;
    $[111] = t58;
  } else {
    t58 = $[111];
  }
  let t59;
  if ($[112] !== t54 || $[113] !== t58) {
    t59 = <Stack direction="row" sx={t28}>{t54}{t58}</Stack>;
    $[112] = t54;
    $[113] = t58;
    $[114] = t59;
  } else {
    t59 = $[114];
  }
  let t60;
  if ($[115] !== t27 || $[116] !== t59) {
    t60 = <Container component="footer" maxWidth="xxl" sx={t18} data-testid="Footer"><Stack spacing={7.5}>{t27}{t59}</Stack></Container>;
    $[115] = t27;
    $[116] = t59;
    $[117] = t60;
  } else {
    t60 = $[117];
  }
  return t60;
}
function _temp3(link_0) {
  return <FooterLink key={link_0.name} url={link_0.href} label={link_0.name} sx={{
    fontSize: 13,
    lineHeight: {
      xs: 1.7,
      sm: 1.2
    },
    fontWeight: "bold"
  }} />;
}
function _temp2(link) {
  return <FooterLink key={link.name} url={link.href} label={link.name} src={link.icon} width={32} height={32} target="_blank" noFollow={true} sx={{
    lineHeight: 0,
    opacity: "0.77",
    transition: _temp,
    "&:hover": {
      transform: "scale(1.1)"
    }
  }} />;
}
function _temp(theme) {
  return theme.transitions.create("transform");
}